import { AlertCircle, AlertTriangle } from "lucide-react";
import { useAttention } from "./queries";

export function AttentionStrip({ onArchiveClick }: { onArchiveClick: (status: string) => void }) {
  const { data } = useAttention();

  if (!data || (data.failed === 0 && data.stalled === 0)) return null;

  return (
    <div className="flex items-center gap-6 px-4 py-3 bg-rose-500/10 border-b border-rose-500/20 text-rose-200">
      <div className="flex items-center gap-2">
        <AlertCircle className="w-5 h-5 text-rose-500" />
        <span className="font-medium">Attention Required</span>
      </div>

      <div className="flex gap-4 text-sm">
        {data.failed > 0 && (
          <button 
            onClick={() => onArchiveClick("failed")}
            className="flex items-center gap-1.5 hover:text-rose-100 transition-colors"
          >
            <span className="bg-rose-500/20 px-2 py-0.5 rounded-full font-mono text-xs">{data.failed}</span>
            <span>Failed Batches</span>
          </button>
        )}
        
        {data.stalled > 0 && (
          <button 
            onClick={() => onArchiveClick("running")}
            className="flex items-center gap-1.5 hover:text-rose-100 transition-colors"
          >
            <AlertTriangle className="w-4 h-4 text-orange-400" />
            <span className="bg-orange-500/20 text-orange-300 px-2 py-0.5 rounded-full font-mono text-xs">{data.stalled}</span>
            <span className="text-orange-200">Stalled (No updates &gt; 24h)</span>
          </button>
        )}
      </div>
    </div>
  );
}
